import axios from 'axios';

export const fetchAppointments = async () => {
  try {
    const response = await axios.get('https://ricgop.online/api/getAppointments.php');
    return response.data;
  } catch (error) {
    console.error('Fetch appointments error:', error);
    throw error;
  }
}